<template>
    <div class="share-footer" :style="propStyle">
        <!-- bg -->
        <div class="share-footer-bg">
            <img :src="require('@/assets/images/YuliApp/badgeWall/share/bg_lead.png')">
        </div>
        <div class="share-footer-buttonView">
            <div class="share-footer-buttonView-left">
                <img @click="toParentHandle('close')" :src="require('@/assets/images/YuliApp/badgeWall/share/icon_close.png')">
            </div>
            <div class="share-footer-buttonView-right">
                <img @click="toParentHandle('download')" :src="require('@/assets/images/YuliApp/badgeWall/share/icon_download.png')">
                <img @click="toParentHandle('share')" :src="require('@/assets/images/YuliApp/badgeWall/share/icon_share.png')">
            </div>
        </div>
    </div>
</template>

<script>
import { onBeforeMount, onMounted, ref, computed, nextTick } from "vue";
import _ from "lodash";
import { mapState } from "vuex";

export default {
components: {},
props: {
    propStyle: {
        type: Object,
        default: ()=>{
            return {}
        },
    },
},
computed: {
    ...mapState({
        languageEnv: (state) => state.global.languageEnv,
        languagePackage: (state) => state.global.languagePackage,
    }),
},
watch: {
    languageEnv: {
        async handler(value) {
            if(value){
                this.localesEnv = value;
            }
        },
        immediate: true,
        deep: true,
    },
    languagePackage: {
        async handler(value) {
            if(value){
                this.localesPackage = value;
            }
        },
        immediate: true,
        deep: true,
    },
},
setup(props, { emit }) {
    // const {  } = props;
    /**语言包 - ref */
    const localesPackage = ref({});
    /**语言环境 - ref */
    const localesEnv = ref('en');
    const toParentHandle = (type) => {
        emit('handle', type);
    }

    return {
        toParentHandle,
        localesPackage,
        localesEnv
    };
},
};
</script>
  
<style lang="less" scoped>
    .share-footer{
        position: absolute;
        width: 100%;
        height: 85px;
        bottom: 0;
        left: 0;
        padding: 10px 25px;
        box-sizing: border-box;
        z-index: 999;
        &-bg{
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            z-index: -1;
        }
        &-buttonView{
            width: 100%;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            img{
                width: 44px;
                height: 44px;
            }
            &-left{
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: center;
            }
            &-right{
                width: 115px;
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: space-around;
            }
        }
    }
</style>
  